import ticketDiamondPng from '/img/icons/ticket-diamond.png';
import ticketDiamondWebp from '/img/icons/ticket-diamond.webp';
import ticketGoldPng from '/img/icons/ticket-gold.png';
import ticketGoldWebp from '/img/icons/ticket-gold.webp';
import ticketSilverPng from '/img/icons/ticket-silver.png';
import ticketSilverWebp from '/img/icons/ticket-silver.webp';
import diamond3dPng from '/img/lottery/diamond.png';
import diamond3dWebp from '/img/lottery/diamond.webp';
import gold3dPng from '/img/lottery/gold.png';
import gold3dWebp from '/img/lottery/gold.webp';
import silver3dPng from '/img/lottery/silver.png';
import silver3dWebp from '/img/lottery/silver.webp';

export const ticketImages = {
  silver: {
    png: ticketSilverPng,
    webp: ticketSilverWebp,
  },
  silver3d: {
    png: silver3dPng,
    webp: silver3dWebp,
  },
  gold: {
    png: ticketGoldPng,
    webp: ticketGoldWebp,
  },
  gold3d: {
    png: gold3dPng,
    webp: gold3dWebp,
  },
  diamond: {
    png: ticketDiamondPng,
    webp: ticketDiamondWebp,
  },
  diamond3d: {
    png: diamond3dPng,
    webp: diamond3dWebp,
  },
} as const;
